export type TimeRangeSelection = {
  days?: string;
  value?: string;
  startDate?: string;
  endDate?: string;
};

export const applyTimeRangeSelection = (
  selection: TimeRangeSelection,
  setTimeRange: (value: string) => void,
  setStartDate: (value: string | undefined) => void,
  setEndDate: (value: string | undefined) => void
) => {
  const selectedValue = selection.days || selection.value || "all";
  if (selectedValue === "all") {
    setTimeRange("all");
    setStartDate(undefined);
    setEndDate(undefined);
    return;
  }

  setTimeRange(selectedValue);
  setStartDate(selection.startDate);
  setEndDate(selection.endDate);
};

export const normalizeListResponse = <T>(responseData: unknown): T[] => {
  if (Array.isArray(responseData)) return responseData as T[];
  if (!responseData || typeof responseData !== "object") return [];

  const maybeData = (responseData as { data?: unknown }).data;
  if (Array.isArray(maybeData)) return maybeData as T[];

  const maybeResult = (responseData as { result?: unknown }).result;
  if (Array.isArray(maybeResult)) return maybeResult as T[];

  return [responseData as T];
};

